define('views/parts/header/default-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/panel-header',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VPanelHeader
) {

    var VDefaultHeader = VPanelHeader.extend({
        className: 'default-header dark-color',
    });

    return VDefaultHeader;

});

